import { render, staticRenderFns } from "./CurrencyBankAccounts.vue?vue&type=template&id=7d463cf8"
import script from "./CurrencyBankAccounts.vue?vue&type=script&lang=js"
export * from "./CurrencyBankAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports